import { observable, toJS, flow, action } from "mobx";
import {
	getWizards,
	renameWizard,
	deleteWizards,
	addWizard,
	duplicateWizard
} from "services/wizards";
import { registerHandler, delay } from "services/api";
import { message } from "antd";

export default class XWizardsStore {
	constructor() {
		this.wizards = observable.array([]);
		this.strategies = observable.array([]);
		this.ui = this.getUI();
	}

	getUI = () => {
		let ui = {
			loadingWizards: false,			
			addWizardDialogVisible: false,
			addEditWizardDialogVisible: false,
			duplicateWizardDialogVisible: false,
			duplicatedWizard: null,
			editedWizard: null, //When editedWizard is not null, it means that we are editing that wizard name
			renamingWizard: false,
			deletingWizards: false,
			addingWizard: false,
			duplicatingWizard: false
		};
		return observable.object(ui);
	};

	@action
	showAddWizardDialog = () => {
		this.ui.addWizardDialogVisible = true;
		this.ui.editedWizard = null;
	};

	@action
	hideAddWizardDialog = () => {
		this.ui.addWizardDialogVisible = false;
		this.ui.editedWizard = null;
	};

	@action
	showDuplicateWizardDialog = wizard => {
		this.ui.duplicateWizardDialogVisible = true;
		this.ui.duplicatedWizard = wizard;
	};

	@action
	hideDuplicateWizardDialog = () => {
		this.ui.duplicateWizardDialogVisible = false;
		this.ui.duplicatedWizard = null;
	};

	@action
	showEditWizardDialog = wizard => {
		this.ui.addEditWizardDialogVisible = true;
		this.ui.editedWizard = wizard;
	};

	@action
	hideAddEditWizardDialog = () => {
		this.ui.addEditWizardDialogVisible = false;
		this.ui.editedWizard = null;
	};

	// createCampaign = flow(function*(name) {
	// 	this.ui.creatingCampaign = true;
	// 	const response = yield createCampaign(name);
	// 	this.ui.creatingCampaign = false;

	// 	if (response == null) {
	// 		message.error("Failed to create new campaign. Unknown error", 3);
	// 		return;
	// 	}

	// 	if (response.error) {
	// 		message.error(response.error.message, 3);
	// 		return;
	// 	}

	// 	message.success("Successfully created a new campaign", 3);
	// 	this.ui.addCampaignDialogVisible = false;
	// 	this.ui.editedCampaign = null;
	// });

	//wizard is 
	// {
	// 	name: name,
	// 	strategy: strategy (startegy here is id)
	// }

	remoteDuplicateWizard = flow(function*(wizard) {
		this.ui.duplicatingWizard = true;
		const response = yield duplicateWizard(wizard);
		this.ui.duplicatingWizard = false;

		if (response == null) {
			message.error("Failed to duplicate wizard. Unknown error.");
			return;
		}	
		
		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		message.success("Successfully duplicated wizard");

		this.hideDuplicateWizardDialog();
	})

	remoteAddWizard = flow(function*(wizard) {
		this.ui.addingWizard = true;

		const payload = {	
			id: 0,		
			strategy: wizard.strategy,
			name: wizard.name
		};
				
		const response = yield addWizard(payload);

		this.ui.addingWizard = false;

		if (response == null) {
			message.error("Failed to add new wizard. Unknown error", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		message.success("Successfully added new wizard", 5);
		this.ui.addWizardDialogVisible = false;		
		return;
	});

	remoteRenameWizard = flow(function*(wizardName) {
		this.ui.renamingWizard = true;
		const payload = {
			id: this.ui.editedWizard.id,
			name: wizardName
		}
		const response = yield renameWizard(payload);
		this.ui.renamingWizard = false;
		if (response == null) {
			message.error("Failed to rename the wizard. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully rename the wizard", 3);

		this.ui.addEditWizardDialogVisible = false;
		this.ui.editedWizard = null;
	});

	@action
	renameWizard = wizard => {
		const foundIndex = this.wizards.findIndex(el => {
			return el.id == wizard.id;
		});

		if (foundIndex != -1) {
			this.wizards[foundIndex].name = wizard.name;
		}
	};

	remoteDeleteWizards = flow(function*(ids) {
		this.ui.deletingWizards = true;
		const response = yield deleteWizards(ids);
		this.ui.deletingWizards = false;

		if (response == null) {
			message.error("Failed to delete selected wizards. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully deleted selected wizards", 3);
	});

	@action
	deleteWizards = ids => {
		this.wizards = observable.array(
			this.wizards.filter(wizard => !ids.includes(wizard.id))
		);
	};

	@action
	addWizard = wizard => {
		this.wizards.push(wizard);
	};

	loadWizards = flow(function*() {
		this.ui = this.getUI();
		this.ui.loadingWizards = true;
		const response = yield getWizards();
		this.ui.loadingWizards = false;
		if (response == null) {
			message.error("Failed to load wizards. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}
		this.wizards = observable.array(response.wizards);	
		this.strategies = observable.array(response.strategies);

		registerHandler([
			{
				path: "xwizards",
				handler: (err, msg) => {
					if (err != null) return;
					const obj = JSON.parse(msg.body);
					if (obj.action == "addWizard") {
						var wizard = obj.wizard;
						this.addWizard(wizard);
						return;
					}

					if (obj.action == "renameWizard") {						
						var wizard = obj.wizard;
						this.renameWizard({
							name: wizard.name,
							id: wizard.id
						});
						return;
					}

					if (obj.action == "deleteWizards") {
						this.deleteWizards(obj.ids);
						return;
					}
				}
			}
		]);
	});
}
